/* 🤖 this file was generated by svg-to-ts */
export const PorIconChevronright: {
    name: 'chevronright';
    data: string;
} = {
    name: 'chevronright',
    data: `<!--From https://fonts.google.com/icons Icon: Chevron Right, Weight: 700 Grade: 200--><svg xmlns="http://www.w3.org/2000/svg" height="24" viewBox="0 96 960 960" width="24"><path d="m375 837-65-65 198-197-198-198 65-65 263 263-263 262Z"/></svg>`
};
